import React, { useState, useEffect } from "react";

import Screen from "../components/Screen";
import useApi from "../hooks/useApi";
import locationsApi from "../api/locations";
import ListItem from "../components/lists/ListItem";
import IconTouchable from "../components/IconTouchable";
import { FlatList, View } from "react-native";

function LocationDetailsScreen({ navigation, route }) {
    const [message, setMessage] = useState(false);
    const [items, setItems] = useState();

    const lookupLocationItemsApi = useApi(locationsApi.lookupItems);

    useEffect(() => {
        getItems();
    }, []);

    const getItems = async () => {
        const response = await lookupLocationItemsApi.request(route.params.items);
        if (response.ok) {
            setItems(response.data);
        }
    };

    return (
        <Screen navigation={navigation} title={"Location Details"} message={message} setMessage={setMessage}>
            <FlatList
                data={items}
                keyExtractor={(item) => item._id}
                showsVerticalScrollIndicator={false}
                renderItem={({ item }) => <ListItem title={item.name} onPress={() => navigation.navigate("VehicleDetails", item)} />}
            />
        </Screen>
    );
}

export default LocationDetailsScreen;
